import React from 'react';
import styled from 'styled-components/macro';
import { Draggable } from 'react-beautiful-dnd';

const StyledDragElement = styled.div<{ isDragging: boolean }>`
  transition: all 0.5s ease-in;
  width: 100%;
  user-select: none;
  height: 30px;
  margin-top: 5px;
  margin-left: 10px;
  border-bottom: 5px solid ${({ theme }) => theme.colorPalette.turquoise.normal};
  line-height: 30px;
  text-align: left;
  opacity: ${({ isDragging }) => (isDragging ? 1 : 0.75)};
`;

const Text = styled.p<{ isDragging: boolean }>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
  font-weight: ${({ isDragging }) => !isDragging && 300};
`;

const NumIndex = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5};
  display: flex;
  align-items: baseline;
`;

export interface CardProps {
  name: string;
  index: number;
}

const DraggableCard = (props: CardProps) => {
  return (
    <Draggable index={props.index} draggableId={props.name}>
      {(provided, snapshot) => {
        return (
          <NumIndex ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <Text isDragging={false}>{props.index}</Text>
            <StyledDragElement isDragging={snapshot.isDragging}>
              <Text isDragging={snapshot.isDragging}>{props.name}</Text>
            </StyledDragElement>
          </NumIndex>
        );
      }}
    </Draggable>
  );
};

export default DraggableCard;
